import JSZip from "jszip";
import { saveAs } from "file-saver";

// Test function to verify the download utility works
export const testDownloadCypressProject = () => {
  const testData = [
    { "package.json": '{"name": "test-project", "version": "1.0.0"}' },
    { "cypress.config.js": "const { defineConfig } = require('cypress'); module.exports = defineConfig({});" },
    { "cypress/support/e2e.js": "// Test support file" },
    { "cypress/e2e/test.cy.js": "describe('Test', () => { it('should work', () => {}); });" }
  ];
  
  console.log("Testing download with sample data:", testData);
  return downloadCypressProject(testData);
};

export const downloadCypressProject = (projectData, setZipBlob = null) => {
  try {
    console.log("downloadCypressProject called with:", projectData);
    console.log("projectData type:", typeof projectData);
    console.log("projectData is array:", Array.isArray(projectData));
    
    const zip = new JSZip();

    // Handle the array format returned by the backend
    // projectData is an array of objects where each object has a file name as key and content as value
    if (Array.isArray(projectData)) {
      console.log("Processing array with", projectData.length, "items");
      projectData.forEach((fileObj, index) => {
        console.log(`File object ${index}:`, fileObj);
        // Each fileObj is like { "fileName": "content" }
        const fileName = Object.keys(fileObj)[0];
        const content = fileObj[fileName];
        
        console.log(`Processing file: ${fileName}, content length: ${content ? content.length : 0}`);
        
        if (fileName && content) {
          // Handle different file types and organize them in the zip structure
          if (fileName === "package.json") {
            zip.file("package.json", content);
            console.log("Added package.json to zip");
          } else if (fileName === "cypress.config.js") {
            zip.file("cypress.config.js", content);
            console.log("Added cypress.config.js to zip");
          } else if (fileName === "README.md") {
            zip.file("README.md", content);
            console.log("Added README.md to zip");
          } else if (fileName.startsWith("cypress/support/")) {
            // Support files
            const supportFolder = zip.folder("cypress/support");
            const relativePath = fileName.replace("cypress/support/", "");
            supportFolder.file(relativePath, content);
            console.log(`Added support file: ${relativePath}`);
          } else if (fileName.startsWith("cypress/e2e/")) {
            // Test files
            const e2eFolder = zip.folder("cypress/e2e");
            const relativePath = fileName.replace("cypress/e2e/", "");
            // Ensure test files have .cy.js extension
            const fileExtension = relativePath.endsWith('.cy.js') ? '' : '.cy.js';
            e2eFolder.file(`${relativePath}${fileExtension}`, content);
            console.log(`Added test file: ${relativePath}${fileExtension}`);
          } else if (fileName.startsWith("cypress/support/page-objects/")) {
            // Page objects
            const pageObjectsFolder = zip.folder("cypress/support/page-objects");
            const relativePath = fileName.replace("cypress/support/page-objects/", "");
            const fileExtension = relativePath.endsWith('.js') ? '' : '.js';
            pageObjectsFolder.file(`${relativePath}${fileExtension}`, content);
            console.log(`Added page object: ${relativePath}${fileExtension}`);
          } else if (fileName.startsWith("cypress/fixtures/")) {
            // Fixtures
            const fixturesFolder = zip.folder("cypress/fixtures");
            const relativePath = fileName.replace("cypress/fixtures/", "");
            fixturesFolder.file(relativePath, content);
            console.log(`Added fixture: ${relativePath}`);
          } else if (fileName.startsWith("cypress/reports/")) {
            // Reports
            const reportsFolder = zip.folder("cypress/reports");
            const relativePath = fileName.replace("cypress/reports/", "");
            reportsFolder.file(relativePath, content);
            console.log(`Added report: ${relativePath}`);
          } else {
            // For any other files, add them to the root
            zip.file(fileName, content);
            console.log(`Added root file: ${fileName}`);
          }
        } else {
          console.warn(`Skipping file object ${index}: fileName=${fileName}, content=${content ? 'present' : 'missing'}`);
        }
      });
    } else {
      // Fallback for old format or single file
      console.warn("Unexpected project data format:", projectData);
      return false;
    }

    console.log("Zip file contents before generation:", zip.files);
    
    // Generate and download the zip file
    zip.generateAsync({ type: "blob" }).then((content) => {
      console.log("Generated zip blob size:", content.size);
      saveAs(content, "Cypress_Project.zip");
      console.log("Zip file downloaded successfully");
      
      // Store the blob for GitHub push if setZipBlob is provided
      if (setZipBlob) {
        setZipBlob(content);
      }
    });

    return true;
  } catch (error) {
    console.error("Error creating Cypress project zip:", error);
    return false;
  }
}; 